import { LookbookBrand } from '@/types/activation/lookbook';
import { LOOKBOOK_DESIGNS, LookbookCover, LookbookClosing } from './lookbookDesigns';
import { LookbookPageFrame, LOOKBOOK_PAGE_W, LOOKBOOK_PAGE_H } from './LookbookPageFrame';

const pageStyle = { width: LOOKBOOK_PAGE_W, height: LOOKBOOK_PAGE_H } as const;

/**
 * The full lookbook as a stack of A4 page nodes — cover, every placement, and
 * the closing page. Each page carries `data-lookbook-page` so the PDF generator
 * can rasterize them in order. Rendered offscreen; never shown in the app tree.
 */
export const LookbookDocument = ({ brand }: { brand: LookbookBrand }) => (
  <>
    <div data-lookbook-page data-kind="cover" style={pageStyle}>
      <LookbookCover brand={brand} />
    </div>
    {LOOKBOOK_DESIGNS.map((design, i) => (
      <div key={design.id} data-lookbook-page data-kind="design" style={pageStyle}>
        <LookbookPageFrame brand={brand} design={design} index={i + 1} total={LOOKBOOK_DESIGNS.length} />
      </div>
    ))}
    <div data-lookbook-page data-kind="closing" style={pageStyle}>
      <LookbookClosing brand={brand} />
    </div>
  </>
);
